import { useMemo } from "react";

import { useLocalStorage } from "@honeycomb/mystique";

export type IconHiveryProps = {
  width: string;
  height: string;
};

export const IconHivery = ({ width, height }: IconHiveryProps) => {
  const [uiTheme] = useLocalStorage<string>({
    key: "uiTheme",
    defaultValue: "classic",
    onExternalUpdate: () => {
      window.location.reload();
    },
  });
  const icon = useMemo(() => {
    switch (uiTheme) {
      case "mars":
        return (
          <svg
            width={width}
            height={height}
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 111.2 126.5"
          >
            <g>
              <path
                fill="#FFFFFF"
                d="M55.6,53.9c-0.5-0.5-1-0.9-1.5-1.4C43.8,42,33.6,31.6,23.3,21.2c-6-6.1-12-12.2-18-18.3C3.9,1.4,2.3,0.4,0,0
             v126.2c3.6,0.4,23.8,0.3,25.4-0.2c0-0.1,0.1-0.1,0.1-0.2c0-19.5,0-39,0-58.6c0-0.2,0-0.3,0-0.5c0-0.1,0.1-0.2,0.1-0.2
             s0.1-0.1,0.3-0.2l29.6,30.1L55.6,53.9C55.6,53.8,55.6,53.8,55.6,53.9z"
              ></path>
              <path
                fill="#00D7B9"
                d="M60.6,91.3c1.7-1.7,3.4-3.4,5.1-5.1l4.9-5l4.9-5c1.7-1.7,3.3-3.4,5.1-5.1c1.6-1.6,3-3.3,5.2-5v60
             c4.3,0.4,23.9,0.3,25.6-0.2V1.3c0-0.3,0-0.6-0.1-1c0-0.1-0.1-0.1-0.1-0.2C111.1,0,111.1,0,111-0.1c-2.1,0.3-3.7,1.5-5.2,3
             c-16.3,16.6-32.5,33-48.6,49.5c-0.5,0.5-1,0.9-1.5,1.4v42.7l0.1,0.1C57.4,94.7,59,93,60.6,91.3z"
              ></path>
            </g>
          </svg>
        );
      default:
        return (
          <svg
            width={width}
            height={height}
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 55 55`}
            fill="currentColor"
          >
            <path
              transform="translate(4, 0)"
              d="M26.06,52.27,12.52,44.42V31.1L1,24.43V8.86L14.56,1l11.5,6.66L37.55,1,51.12,8.87V24.43L39.6,31.1V44.42ZM16.55,42.1l9.51,5.51,9.51-5.51V28.78L47.09,22.1V11.19L37.55,5.65,26.06,12.31,14.56,5.65,5,11.18V22.11l11.52,6.67Z"
            />
          </svg>
        );
    }
  }, [height, uiTheme, width]);

  return <>{icon}</>;
};
